(function () {
  function stepOf(track) {
    var s = track.querySelector('[data-reel-slide]');
    if (!s) return track.clientWidth;
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    return s.getBoundingClientRect().width + gap;
  }

  function initReel(root) {
    if (root.dataset.reelReady) return;
    root.dataset.reelReady = '1';
    var track = root.querySelector('[data-reel-track]');
    var prev = root.querySelector('[data-reel-prev]');
    var next = root.querySelector('[data-reel-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-reel-dot]'));

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      root.classList.toggle('is-static', max <= 2);
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      var i = Math.round(track.scrollLeft / stepOf(track));
      if (track.scrollLeft >= max - 2) i = dots.length - 1;
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -stepOf(track), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: stepOf(track), behavior: 'smooth' }); });
    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { track.scrollTo({ left: k * stepOf(track), behavior: 'smooth' }); });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    var down = false, moved = false, sx = 0, sl = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; sx = e.clientX; sl = track.scrollLeft;
      track.classList.add('is-drag');
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      if (Math.abs(dx) > 5) moved = true;
      track.scrollLeft = sl - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      var st = stepOf(track);
      var target = Math.round(track.scrollLeft / st) * st;
      track.classList.remove('is-drag');
      track.scrollTo({ left: target, behavior: 'smooth' });
    });
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    update();
  }

  function stopVideo(m) {
    var v = m.querySelector('video');
    if (!v.paused) v.pause();
    m.classList.remove('is-playing');
  }

  function initVideo(m) {
    if (m.dataset.vidReady) return;
    m.dataset.vidReady = '1';
    var v = m.querySelector('video');
    m.addEventListener('click', function () {
      if (v.paused) {
        document.querySelectorAll('[data-reel-video].is-playing').forEach(function (o) { if (o !== m) stopVideo(o); });
        v.muted = true;
        var p = v.play();
        m.classList.add('is-playing');
        if (p && p.catch) p.catch(function () { m.classList.remove('is-playing'); });
      } else {
        stopVideo(m);
      }
    });
    v.addEventListener('ended', function () { m.classList.remove('is-playing'); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (!en.isIntersecting) stopVideo(m); });
      }, { threshold: 0.25 }).observe(m);
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-reel]').forEach(initReel);
    (scope || document).querySelectorAll('[data-reel-video]').forEach(initVideo);
  }

  initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
